export default __webpack_public_path__ + "static/media/07_jewellery_m.eceb428b.webp";